import { useSession } from '@studio/storeV2/authentication/session-store';

const useIsCentralToggleActive = (toggleName: string) => {
  const { toggles } = useSession();
  return Boolean(toggles?.some((i) => i === toggleName));
};

export default useIsCentralToggleActive;
